import { createContext } from "react";
const AttributeContext = createContext({});

export default AttributeContext;
